// modules/dashboard/components/SeccionFormatoCompartido.js
// Vejez, Población Migrante y Habitante de Calle comparten el mismo
// "Formato de Caracterización Población de Alto Valor Constitucional".
import GraficoBarras from "./GraficoBarras";
import { KpiRow, Tarjeta, Grilla, Subtitulo, EstadoVacio, EncabezadoSeccion, Proporcion, pct } from "./Piezas";
import { AZUL_INSTITUCIONAL } from "../utils/colores";

// `etiquetaExcluir`: la categoría de grupo_poblacional que es "obvia" para
// esta estrategia (ej. "Persona mayor" en Vejez) — se quita del gráfico de
// "otros grupos poblacionales" porque ahí siempre va a ser 100%, no aporta nada.
export default function SeccionFormatoCompartido({ id, titulo, emoji, accent, datos, etiquetaExcluir, descripcion }) {
  const d = datos;
  const acento = accent;

  const grupoSinPropio = { ...d.grupoPoblacional };
  delete grupoSinPropio[etiquetaExcluir];

  return (
    <section id={id} className="db-seccion" aria-labelledby={`${id}-titulo`}>
      <EncabezadoSeccion id={id} emoji={emoji} titulo={titulo} total={d.total} acento={acento} descripcion={descripcion} />

      {d.total === 0 ? (
        <EstadoVacio emoji={emoji} texto="Ningún registro de esta estrategia con los filtros actuales." />
      ) : (
        <>
          <KpiRow acento={acento} items={[
            { valor: d.edadPromedio, unidad: "años", etiqueta: `Edad promedio (${d.edadMin}–${d.edadMax} años)` },
            { valor: `${pct(d.genero["Femenino"] || 0, d.total)}%`, etiqueta: `Mujeres · ${pct(d.genero["Masculino"] || 0, d.total)}% hombres` },
            { valor: `${pct(d.pertenenciaDiferencial["Indígena"] || 0, d.total)}%`, etiqueta: "Pertenencia indígena" },
            { valor: `${pct(d.enfermedadesCronicas["Sí"] || 0, d.total)}%`, etiqueta: "Con enfermedad crónica" },
            { valor: `${pct(d.vacunacion["Sí"] || 0, d.total)}%`, etiqueta: "Vacunación al día" },
          ]} />

          <Subtitulo>Perfil y territorio</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Personas por comunidad" ancho={7}><GraficoBarras datos={d.comunidad} color={acento} topN={12} /></Tarjeta>
            <Tarjeta titulo="Género" ancho={5}>
              <Proporcion datos={d.genero} destacar="Femenino" etiqueta="mujeres" colores={{ Femenino: acento, Masculino: AZUL_INSTITUCIONAL }} />
              <div style={{ marginTop: 22 }}>
                <h3 style={{ fontSize: "0.9rem", fontWeight: 700, margin: "0 0 10px" }}>Pertenencia étnica</h3>
                <GraficoBarras datos={d.etnia} color={acento} topN={6} />
              </div>
            </Tarjeta>
            <Tarjeta titulo="Estado civil" ancho={6}><GraficoBarras datos={d.estadoCivil} color={acento} /></Tarjeta>
            <Tarjeta titulo="Nivel educativo" ancho={6}><GraficoBarras datos={d.nivelEducativo} color={acento} /></Tarjeta>
          </Grilla>

          <Subtitulo>Salud y funcionalidad</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Vacunación al día" ancho={4}><Proporcion datos={d.vacunacion} destacar="Sí" acento={acento} etiqueta="al día" /></Tarjeta>
            <Tarjeta titulo="Enfermedad crónica" ancho={4}><Proporcion datos={d.enfermedadesCronicas} destacar="Sí" acento={acento} etiqueta="con enfermedad crónica" /></Tarjeta>
            <Tarjeta titulo="Estado funcional" ancho={4}><Proporcion datos={d.estadoFuncional} destacar="Independiente" acento={acento} etiqueta="independiente" /></Tarjeta>
            <Tarjeta titulo="Estado de ánimo" ancho={12}><GraficoBarras datos={d.estadoAnimo} color={acento} horizontal={false} alto={190} /></Tarjeta>
          </Grilla>

          <Subtitulo>Determinantes sociales y necesidades</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Necesidades principales" nota="Selección múltiple" ancho={6}><GraficoBarras datos={d.necesidades} color={acento} /></Tarjeta>
            <Tarjeta titulo="Barreras de acceso identificadas" nota="Selección múltiple" ancho={6}><GraficoBarras datos={d.barreras} color={acento} /></Tarjeta>
            <Tarjeta titulo="Tipo de vivienda" ancho={4}><GraficoBarras datos={d.tipoVivienda} color={acento} /></Tarjeta>
            <Tarjeta titulo="Fuente de ingresos" ancho={4}><GraficoBarras datos={d.ingresos} color={acento} /></Tarjeta>
            <Tarjeta titulo="Red de apoyo" nota="Selección múltiple" ancho={4}><GraficoBarras datos={d.redApoyo} color={acento} /></Tarjeta>
            <Tarjeta titulo="Pertenece también a otros grupos poblacionales" nota="No excluyentes — base de la réplica entre estrategias" ancho={12}>
              <GraficoBarras datos={grupoSinPropio} color={acento} />
            </Tarjeta>
          </Grilla>

          <Subtitulo>Gestión</Subtitulo>
          <Grilla>
            <Tarjeta titulo="Registros por gestor/a" ancho={12}><GraficoBarras datos={d.gestor} color={AZUL_INSTITUCIONAL} /></Tarjeta>
          </Grilla>
        </>
      )}
    </section>
  );
}
